import * as React from 'react';
import { Link as _Link, LinkProps as _LinkProps } from 'react-router-dom';

export type LinkProps = Pick<_LinkProps, Exclude<keyof _LinkProps, 'to'>>;
export const Link = (to: string) =>
  React.forwardRef((props: LinkProps, ref: any) => (
    <_Link ref={ref} to={to} {...props} />
  ));
